import { Injectable } from '@angular/core';
import { ValidatorsService } from '@epicuro-next/data/engagement/document-control';
import { MessageType, showSnackBarMessage } from '@epicuro-next/state/snackbar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, delay, map, mergeMap } from 'rxjs/operators';

import * as actions from '../../actions';

const AFTER_LIST_CREATION_DELAY = 500;

@Injectable()
export class PatchEffects {
  constructor(
    private actions$: Actions,
    private validatorsService: ValidatorsService,
  ) {}

  public patchListValidators$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.patchValidators),
      mergeMap(({ list, entityValidators }) =>
        this.validatorsService.patchValidators(entityValidators).pipe(
          map((response) => actions.patchValidatorsSuccess(response)),
          catchError(() =>
            of(
              actions.patchValidatorsFail({
                listName: list.name,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  public patchListValidatorsFailed$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.patchValidatorsFail),
      delay(AFTER_LIST_CREATION_DELAY),
      map(({ listName }) =>
        showSnackBarMessage({
          message: $localize`:@@PatchListValidatorsFailedSnackMessage:${listName} failed to add validators.`,
          messageType: MessageType.DANGER,
        }),
      ),
    ),
  );
}
